import type { ReactNode } from 'react'
import './page-hero.css'

export type PageHeroVariant = 'services' | 'request' | 'contact' | 'inventory' | 'vehicle' | 'privacy'

export type PageHeroMedia = {
  src: string
  alt: string
  focalPoint?: string
}

type PageHeroProps = {
  variant: PageHeroVariant
  eyebrow: ReactNode
  title: ReactNode
  children?: ReactNode
  media?: PageHeroMedia
  className?: string
}

export function PageHero({ variant, eyebrow, title, children, media, className }: PageHeroProps) {
  const classes = ['page-hero', `page-hero--${variant}`, media ? 'page-hero--with-media' : '', className ?? '']
    .filter(Boolean)
    .join(' ')

  return (
    <header className={classes}>
      <div className="page-frame page-hero__grid">
        <p className="page-hero__eyebrow">{eyebrow}</p>
        <div className="page-hero__identity">
          <h1 tabIndex={-1}>{title}</h1>
        </div>
        {children ? <div className="page-hero__content">{children}</div> : null}
        {media ? (
          <div className="page-hero__media">
            <img src={media.src} alt={media.alt} style={media.focalPoint ? { objectPosition: media.focalPoint } : undefined} />
          </div>
        ) : null}
      </div>
    </header>
  )
}
